import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "notification-badge"

  connect() {
    super.connect()
    this.send("connect", {}, () => {
      window.dispatchEvent(new CustomEvent("notification-badge:sync"))
    })
  }

  update({ detail: { count } }) {
    this.send("update", { count })
  }

  markSeen({ detail: { perform } }) {
    this.send("mark-seen", {}, ({ data }) => {
      if (data.visible) perform()
    })
  }
}
